import { FrameName } from "../config";
import TileEntity from "../TileEntity";

type FishingTrapsFrameNames =
	| FrameName.SHALLOW_SEA_SMALL_FISH_TRAP
	| FrameName.SHALLOW_SEA_MEDIUM_FISH_TRAP;

class ShallowSeaSmallFishTrapBuildingTileEntity extends TileEntity {
	public static readonly frameName: FishingTrapsFrameNames =
		FrameName.SHALLOW_SEA_SMALL_FISH_TRAP;
}

export default ShallowSeaSmallFishTrapBuildingTileEntity;
